import { render } from "./AssetType.vue?vue&type=template&id=60d36f10"
import script from "./AssetType.vue?vue&type=script&lang=js"
export * from "./AssetType.vue?vue&type=script&lang=js"

import exportComponent from "F:\\PWAs\\mode-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__